import { useCallback } from 'react';
import Promise from 'bluebird';
import { http } from '@bingads-webui/http-util';
import { isLatLongCoordinates } from '../util/index';

const BING_MAPS_API_STRUCTURED_URL = 'https://dev.virtualearth.net/REST/v1/Locations/';
const BING_MAPS_API_UNSTRUCTURED_URL = 'https://dev.virtualearth.net/REST/v1/Locations?query=';

export function useLocationsFromBingMapsApi(apiKey, userRegion, locale) {
  // https://docs.microsoft.com/en-us/bingmaps/rest-services/locations/find-a-location-by-query
  const getLocationsFromBingMapsApi = useCallback((query) => {
    if (apiKey) {
      const data = {
        key: apiKey,
        o: 'json',
        incl: 'ciso2',
        userRegion,
        c: locale,
      };

      // NOTE: Lat/long coordinates require the "structured" URL but all other queries should be unstructured
      const url = isLatLongCoordinates(query) ? BING_MAPS_API_STRUCTURED_URL : BING_MAPS_API_UNSTRUCTURED_URL;

      return http.get(`${url}${encodeURIComponent(query)}`, {
        data,

        // to avoid a CORS check, content type needs to be empty string
        // see: https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        contentType: '',
      });
    }
    return Promise.resolve(null);
  }, [apiKey, userRegion, locale]);

  return getLocationsFromBingMapsApi;
}
